<template>
  <v-app>
    <v-content>
      <v-container :class="computedClass">
           <v-progress-linear
            v-if="quizStarted"
            background-color="grey"
            background-opacity="0.3"
            color="#87be23"
            height="30"
            :value="100/9 * currentQuestion"
            class="progressbar"
          ></v-progress-linear>
          <v-fade-transition mode="out-in">
            <router-view  :key="$route.fullPath" />
          </v-fade-transition>
      </v-container>
    </v-content>
    <v-footer></v-footer>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState('metsankayttaja', ['quizStarted', 'currentQuestion']),
    computedClass() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return "hola"
        case 'sm': return ''
        case 'md': return ''
        case 'lg': return ''
        case 'xl': return ''
      }
    }
  }
}
</script>

<style scoped>
.hola {
  padding: 0;
}
</style>
